<template>

    <section class="hero">
        <div class="hero-content xl:py-spc5 md:py-10">
            <div class="container">
                <SectionHeadings
                    titleclass=" xl:text-size2 md:text-size9 "
                    title="Jekyll themes"
                    stitle="— a curated directory "
                    bolddesc="Find the best theme for your next project "
                    desc="from the most comprehensive,
                    supportive and active Jekyll themes and templates website."
                    descclass="xl:text-size3 md:text-size12 mt-spc4 font-normal"
                />
            </div>
        </div>
    </section>
</template>

<script>
    import SectionHeadings from "../common/SectionHeadings";
    export default {
        name: "HeroBanner",
        components: {
            SectionHeadings
        }
    }
</script>

<style scoped>

</style>